/** App-owned theme and CSS system. No component-framework dependency. */
import React, { createContext, useContext, useEffect, useState } from 'react';
export function deepMerge(base, patch) {
    const out = { ...base };
    Object.keys(patch || {}).forEach(key => {
        const value = patch[key];
        out[key] = value && typeof value === 'object' && !Array.isArray(value)
            ? deepMerge(base && typeof base[key] === 'object' ? base[key] : {}, value)
            : value;
    });
    return out;
}
export const shadowValues = [
    'none',
    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
];
const defaultPalette = {
    mode: 'light', common: { black: '#000', white: '#fff' },
    primary: { main: '#1976d2', light: '#42a5f5', dark: '#1565c0', contrastText: '#fff' },
    secondary: { main: '#9c27b0', light: '#ba68c8', dark: '#7b1fa2', contrastText: '#fff' },
    error: { main: '#d32f2f', light: '#ef5350', dark: '#c62828', contrastText: '#fff' },
    warning: { main: '#ed6c02', light: '#ff9800', dark: '#e65100', contrastText: '#fff' },
    info: { main: '#0288d1', light: '#03a9f4', dark: '#01579b', contrastText: '#fff' },
    success: { main: '#2e7d32', light: '#4caf50', dark: '#1b5e20', contrastText: '#fff' },
    text: { primary: 'rgba(0,0,0,0.87)', secondary: 'rgba(0,0,0,0.6)', disabled: 'rgba(0,0,0,0.38)' },
    divider: 'rgba(0,0,0,0.12)', background: { paper: '#fff', default: '#fff' },
    action: { active: 'rgba(0,0,0,0.54)', hover: 'rgba(0,0,0,0.04)', selected: 'rgba(0,0,0,0.08)', disabled: 'rgba(0,0,0,0.26)', disabledBackground: 'rgba(0,0,0,0.12)', focus: 'rgba(0,0,0,0.12)' },
};
export function alpha(color, opacity) {
    if (typeof color !== 'string')
        return color;
    let rgb;
    if (color.startsWith('#')) {
        let hex = color.slice(1);
        if (hex.length === 3)
            hex = hex.split('').map(c => c + c).join('');
        rgb = [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16));
    }
    else {
        const match = color.match(/^rgba?\(([^)]+)\)/);
        if (match)
            rgb = match[1].split(',').slice(0, 3).map(Number);
    }
    return rgb ? `rgba(${rgb.join(',')},${Math.max(0, Math.min(1, opacity))})` : color;
}
function shade(color, factor) {
    const rgb = alpha(color, 1).match(/^rgba\(([^)]+)\)/);
    return rgb ? `rgb(${rgb[1].split(',').slice(0, 3).map(v => Math.floor(Number(v) * (1 - factor))).join(',')})` : color;
}
export function createTheme(options = {}, ...others) {
    const palette = deepMerge(defaultPalette, options.palette || {});
    const standardColors = ['primary', 'secondary', 'error', 'warning', 'info', 'success'];
    standardColors.forEach(key => {
        const color = options.palette?.[key];
        if (!color?.main)
            return;
        const offset = options.palette.tonalOffset || 0.2;
        const rgba = alpha(color.main, 1).match(/^rgba\(([^)]+)\)/);
        const rgb = rgba?.[1].split(',').slice(0, 3).map(Number);
        const luminance = rgb?.map(v => { const c = v / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; });
        const ratio = luminance ? 1.05 / (luminance[0] * 0.2126 + luminance[1] * 0.7152 + luminance[2] * 0.0722 + 0.05) : 21;
        palette[key].light = color.light || (rgb ? `rgb(${rgb.map(v => Math.floor(v + (255 - v) * (offset.light || offset))).join(',')})` : color.main);
        palette[key].dark = color.dark || shade(color.main, offset.dark || offset * 1.5);
        palette[key].contrastText = color.contrastText || (ratio >= (options.palette.contrastThreshold || 3) ? '#fff' : 'rgba(0,0,0,0.87)');
    });
    const values = { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536, ...(options.breakpoints?.values || {}) };
    const easing = { easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)', easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)', easeIn: 'cubic-bezier(0.4, 0, 1, 1)', sharp: 'cubic-bezier(0.4, 0, 0.6, 1)' };
    const theme = deepMerge({
        palette, shape: { borderRadius: 4 }, shadows: shadowValues,
        typography: { fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', fontSize: 14, fontWeightLight: 300, fontWeightRegular: 400, fontWeightMedium: 500, fontWeightBold: 700 },
        zIndex: { mobileStepper: 1000, fab: 1050, speedDial: 1050, appBar: 1100, drawer: 1200, modal: 1300, snackbar: 1400, tooltip: 1500 },
        components: {},
        transitions: { easing, duration: { shortest: 150, shorter: 200, short: 250, standard: 300, complex: 375, enteringScreen: 225, leavingScreen: 195 },
            create: (props = ['all'], o = {}) => (Array.isArray(props) ? props : [props]).map(p => `${p.replace(/[A-Z]/g, m => '-' + m.toLowerCase())} ${o.duration ?? 300}ms ${o.easing || easing.easeInOut} ${o.delay || 0}ms`).join(',') },
    }, options);
    theme.palette = palette;
    const type = theme.typography;
    type.pxToRem = type.pxToRem || (size => `${size / (type.htmlFontSize || 16) * (type.fontSize / 14)}rem`);
    const variants = { h1: [300, 96, 1.167, -1.5], h2: [300, 60, 1.2, -0.5], h3: [400, 48, 1.167, 0], h4: [400, 34, 1.235, 0.25], h5: [400, 24, 1.334, 0], h6: [500, 20, 1.6, 0.15], subtitle1: [400, 16, 1.75, 0.15], subtitle2: [500, 14, 1.57, 0.1], body1: [400, 16, 1.5, 0.15], body2: [400, 14, 1.43, 0.15], button: [500, 14, 1.75, 0.4], caption: [400, 12, 1.66, 0.4], overline: [400, 12, 2.66, 1] };
    Object.entries(variants).forEach(([key, [weight, size, lineHeight, spacing]]) => {
        type[key] = { fontFamily: type.fontFamily, fontWeight: weight, fontSize: type.pxToRem(size), lineHeight,
            letterSpacing: type.fontFamily === '\"Roboto\", \"Helvetica\", \"Arial\", sans-serif' ? `${Math.round(spacing / size * 1e5) / 1e5}em` : 'normal',
            ...(['button', 'overline'].includes(key) && { textTransform: 'uppercase' }), ...type.allVariants, ...type[key] };
    });
    theme.breakpoints = { values, keys: Object.keys(values), up: k => `@media (min-width:${values[k] ?? k}px)`, down: k => `@media (max-width:${(values[k] ?? k) - 0.05}px)`, between: (a, b) => `@media (min-width:${values[a] ?? a}px) and (max-width:${(values[b] ?? b) - 0.05}px)` };
    theme.spacing = typeof options.spacing === 'function' ? options.spacing : (...args) => (args.length ? args : [1]).map(v => typeof v === 'number' ? `${v * (options.spacing || 8)}px` : v).join(' ');
    return others.reduce((t, o) => deepMerge(t, o), theme);
}
export const defaultTheme = createTheme();
const ThemeContext = createContext(defaultTheme);
export const ThemeProvider = ({ theme, children }) => {
    const parent = useContext(ThemeContext);
    return React.createElement(ThemeContext.Provider, { value: typeof theme === 'function' ? theme(parent) : theme || parent }, children);
};
export const useTheme = () => useContext(ThemeContext);
export function useMediaQuery(query, options = {}) {
    const theme = useTheme();
    const text = (typeof query === 'function' ? query(theme) : query || '').replace(/^@media\s*/, '');
    const get = () => typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(text).matches : !!options.defaultMatches;
    const [matches, setMatches] = useState(get);
    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia)
            return undefined;
        const media = window.matchMedia(text);
        const change = () => setMatches(media.matches);
        change();
        if (media.addEventListener)
            media.addEventListener('change', change);
        else
            media.addListener(change);
        return () => { if (media.removeEventListener)
            media.removeEventListener('change', change);
        else
            media.removeListener(change); };
    }, [text]);
    return matches;
}
export const colors = { red: { 500: '#f44336' }, blue: { 500: '#2196f3' }, green: { 500: '#4caf50' }, grey: { 100: '#f5f5f5', 300: '#e0e0e0', 500: '#9e9e9e', 700: '#616161', 900: '#212121' } };
